<template>
    <div class=" bg-white" dir="rtl">
        <div class="flex  items-center py-4 px-4 md:py-31px md:px-26px">
            <div class=" flex items-center flex-grow">
                <div>
                    <svg
                        class="ml-4"
                        width="44"
                        height="44"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g fill="none" fill-rule="evenodd">
                            <circle fill="#FFF" cx="22" cy="22" r="22"></circle>
                            <path
                                d="M37.41 37.703c-2.079-2.374-6.685-6.002-15.431-6.002-8.72 0-13.324 3.607-15.41 5.98A21.932 21.932 0 010 22C0 9.85 9.847 0 22 0c12.15 0 22 9.847 22 22 0 6.15-2.523 11.71-6.59 15.703zM22 27.333A8.667 8.667 0 1022 10a8.667 8.667 0 000 17.333z"
                                fill="#eee"
                                fill-rule="nonzero"
                            ></path>
                        </g>
                    </svg>
                    <!-- <img
                        class=" h-12 w-12 overflow-hidden rounded-full border-3 border-white-200 object-cover object-center"
                        src="https://s2.mihaaru.com/assets/mvelection18candidate1.png"
                    /> -->
                </div>
                <div class="px-2">
                    <h2 class=" font-waheed text-lg text-gray-800 leading-7">
                        {{ article.member.dhivehi_name }}
                    </h2>
                </div>
                <div class="px-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class=" w-4"
                        viewBox="0 0 197 197"
                    >
                        <g fill="none" fill-rule="evenodd">
                            <circle
                                cx="98.5"
                                cy="98.5"
                                r="98.5"
                                fill="#E53E3E"
                            />
                            <g fill="#FFF" transform="translate(81 34)">
                                <ellipse
                                    cx="17"
                                    cy="17.318"
                                    rx="17"
                                    ry="17.318"
                                />
                                <path
                                    d="M17 46.182c9.273 0 16.812 7.475 16.997 16.768l.003.41v46.523C34 119.336 26.389 127 17 127s-17-7.664-17-17.117V63.299c0-9.453 7.611-17.117 17-17.117Z"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
            <div class="flex gap-2 text-13px  text-gray-700">
                <span dir="ltr">{{ article.human_time }}</span>
                <img
                    src="https://cdn.mihaaru.com/assets/mhr/icons/icon-listing-time.svg?v=2"
                    width="16"
                    alt="time icon"
                />
            </div>
        </div>
        <div>
            <h1
                class=" text-27px leading-45px font-waheed px-4 md:px-26px pb-5 pt-4  text-gray-800"
            >
                {{ article.title }}
            </h1>
        </div>
        <!-- <div class="pb-8">
            <div class="pb-4 -mx-4 md:mx-0 md:px-26px">
                <img
                    src="https://cdn.mihaaru.com/photos/2023/06/01/366577_3_83c3e1ce42bf30c54896e51b26429c717138bfad_large.jpg"
                />
            </div>
        </div> -->
        <i-report-slider
            v-if="article.medias"
            :images="article.medias"
        ></i-report-slider>
        <div>
            <div v-for="(content, contentindex) in article.content.content">
                <div
                    v-if="content.type === 'paragraph'"
                    class=" font-faseyha text-lg leading-9 px-4 md:px-26px text-gray-800"
                >
                    <p v-for="parag in content.content">{{ parag.text }}</p>
                </div>

                <!-- <div
                    v-else-if="content.type === 'photo'"
                    class="pb-4 -mx-4 md:mx-0 md:px-26px"
                >
                    <img :src="content.proxy_file_url" />
                    <p>{{ content.text }}</p>
                </div>
                <div v-else-if="content.type === 'youtube video'">
                    <div class="pb-4 -mx-4 md:mx-0 md:px-26px">
                        <iframe
                            width="100%"
                            height="315"
                            :src="
                                `https://www.youtube.com/embed/${content.youtube_id}`
                            "
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
                <div v-else-if="content.type === 'instagram'">
                    <div v-html="content.embed_code"></div>
                </div>
                <div v-else-if="content.type === 'tweet'">
                    <div v-html="content.embed_code"></div>
                </div> -->
            </div>
        </div>

        <!-- <div
            class=" font-faseyha text-lg leading-9 px-4 md:px-26px text-gray-800"
        >
            <p>
                މިއަދާ ހަމައަށް ވެސް އަޅުގަނޑުމެން ދެން ދާންވީ ކޯޓެއް ވެސް
                ނޭނގޭ. ޑްރަގު ކޯޓުތޯ، ކްރިމިނަލް ކޯޓުތޯ ނޫނީ ކޮން ކޯޓެއް ކަމެއް
                ނޭނގޭ. އޭގެ ނަތީޖާއަކަށް ވެގެންދަނީ މަސްތުވާ ހާލުގައި ތިބޭ
                މީހުންނާ ދޭތެރޭގައި ކުރާނެ ކަމެއް ނެތުން ނުވަތަ ގޮތް ހުސްވުން
                އޭނާ ވިދާޅުވީ ޑިޕްލޮމެޓިކް ތައުލީމުގެ ރޮނގުން ސޮއިކުރި
                އެއްބަސްވުމަކީ ދެ ގައުމުގެ ހާރިޖީ ގުޅުން އިތުރަށް ހަރުދަނާވެ، ދެ
                ގައުމުގެ ފޮރިން ސާވިސް އޮފިސަރުންނަށް ތަމްރީނާއި ތަޖުރިބާ ލިބޭނެ
                ފުރުސަތެއް ކަމަށެވެ. ކުޅިވަރުގެ އެއްބަސްވުމުގެ ސަބަބުން ދިވެހި
                އެތުލީޓުންނަށް ސާބިއާގައި ތަމްރީނުވެ ތަޖުރިބާ ހޯދުމަށް އައު
                ދޮރުތަކެއް ހުޅުވޭނެ ކަމަށް ވެސް އޭނާ ވިދާޅުވި އެވެ.
            </p>
        </div> -->
        <div class="pt-8 p-4 flex flex-row-reverse md:px-26px md:pb-31px ">
            <div class=" flex-grow">
                <div class="flex justify-end">
                    <!-- <div
                        class=" flex flex-row-reverse px-4 py-2 border-gray-700 border rounded-full space-x-2 items-center"
                    >
                        <p class=" font-roboto text-xs">Fuvahmulah</p>
                    </div> -->
                </div>
            </div>
            <div class="flex flex-row-reverse space-x-4">
                <div></div>
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
                        />
                    </svg>
                </div>
                <div
                    class=" inline-flex space-x-2 space-x-reverse cursor-pointer"
                >
                    <button @click="likeArticle()">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            class=" text-red-500 w-6 h-6"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                            />
                        </svg>
                    </button>

                    <span>{{ article.total_likes }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IReportSlider from "./IReportSlider.vue";
export default {
    props: {
        article: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        IReportSlider
    },
    methods: {
        likeArticle() {
            axios
                .post(`home/i-reporter/${this.article.uuid}?react=like`)
                .then(response => {
                    console.log(response.data);
                    // handle successful response
                })
                .catch(error => {
                    console.error(error);
                    // handle error response
                });
        },
        dislikeArticle() {
            axios
                .post(`home/i-reporter/${this.article.uuid}?react=dislike`)
                .then(response => {
                    console.log(response.data);
                    // handle successful response
                })
                .catch(error => {
                    console.error(error);
                    // handle error response
                });
        }
    }
};
</script>
